// removed by extract-text-webpack-plugin
module.exports = {"successColor":"#59C19E","errorColor":"#EB5B5B","warningColor":"#e6a23c","primaryColor":"#6578D0","defaultColor":"#b0b0b0","waitingColor":"#9e9e16"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-701bad8e","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/App.vue
// module id = AEJx
// module chunks = 27